import {
  flowInstance,
  mercadoPagoInstance,
  webPayInstance,
} from '../config/paymentConfig'

function createPaymentFlow(data) {
  return flowInstance.post('/users', data)
}

function createPaymentWebpay(data) {
  return webPayInstance.post('/create', data)
}

function getPaymentStatusWebpay(data) {
  return webPayInstance.post('/status', { token: data })
}

function createPaymentMP(data) {
  return mercadoPagoInstance.post('/mercadopago', data)
}

function getPaymentOrderFlow(data) {
  return flowInstance.get('/order', { params: data })
}

export {
  createPaymentFlow,
  createPaymentMP,
  getPaymentOrderFlow,
  createPaymentWebpay,
  getPaymentStatusWebpay,
}
